import { useState, useEffect } from 'react'
import "../styles/Gallery.css";
import chevronLeftIcon from '../images/icons/chevronLeft.png'
import chevronRightIcon from '../images/icons/chevronRight.png'

const Gallery = ({galleryImages}) => {

  const [slideNumber, setSlideNumber] = useState(0)
  const [openModal, setOpenModal] = useState(false)
  const [loadedImages, setLoadedImages] = useState(new Set())
  const [modalImageLoaded, setModalImageLoaded] = useState(false)

  const handleOpenModal = (index) => {
    setSlideNumber(index)
    setOpenModal(true)
    setModalImageLoaded(false)
  }

  // Close Modal
  const handleCloseModal = () => {
    setOpenModal(false)
  }

  // Handle image loaded for thumbnail gallery
  const handleThumbnailLoaded = (index) => {
    setLoadedImages(prev => new Set([...prev, index]))
  }

  // Handle modal image loaded
  const handleModalImageLoaded = () => {
    setModalImageLoaded(true)
  }
  
  // Previous Image
  const prevSlide = () => {
    if (!galleryImages?.length) return;
    const newSlideNumber = (slideNumber - 1 + galleryImages.length) % galleryImages.length;
    setSlideNumber(newSlideNumber);
  }

  // Next Image  
  const nextSlide = () => {
    if (!galleryImages?.length) return;
    const newSlideNumber = (slideNumber + 1) % galleryImages.length;
    setSlideNumber(newSlideNumber);
    setModalImageLoaded(false);
  }

  // Preload adjacent images when modal opens
  useEffect(() => {
    if (!openModal || !galleryImages?.length) return;
    
    const preloadImage = (src) => {
      const img = new Image();
      img.src = src;
    };

    // Preload current, next, and previous images
    preloadImage(galleryImages[slideNumber].src);
    preloadImage(galleryImages[(slideNumber + 1) % galleryImages.length].src);
    preloadImage(galleryImages[(slideNumber - 1 + galleryImages.length) % galleryImages.length].src);
  }, [slideNumber, openModal, galleryImages])

  return (
    <div>

      {openModal && 
        <div className='sliderWrap'>
          <button className="btnClose" onClick={handleCloseModal} aria-label="Close">
            X
          </button>
          <button className="btnPrev" onClick={prevSlide} aria-label="Previous image">
            <img src={chevronLeftIcon} alt="Previous" />
          </button>
          <button className='btnNext' onClick={nextSlide} aria-label="Next image">
            <img src={chevronRightIcon} alt="Next" />
          </button>
          <div className='fullScreenImage'>
            {!modalImageLoaded && <div className='imageSkeleton'></div>}
            <img 
              src={galleryImages[slideNumber].src} 
              alt={galleryImages[slideNumber].caption}
              onLoad={handleModalImageLoaded}
              style={{ opacity: modalImageLoaded ? 1 : 0 }}
            />
            <p className="caption">{galleryImages[slideNumber].caption}</p>
          </div>
        </div>
      }

      <div className='galleryWrap'>
        {
          galleryImages?.map((image, index) => (
            <div
              className='single'
              key={index}
              role="button"
              tabIndex={0}
              onClick={() => handleOpenModal(index)}
              onKeyDown={(e) => e.key === 'Enter' && handleOpenModal(index)}
            >
              {!loadedImages.has(index) && <div className='thumbnailSkeleton'></div>}
              <img 
                src={image.src} 
                alt={image.caption}
                loading="lazy"
                onLoad={() => handleThumbnailLoaded(index)}
                style={{ opacity: loadedImages.has(index) ? 1 : 0, transition: 'opacity 0.3s ease-in' }}
              />
            </div>
          ))
        }
      </div>

    </div>
  )
}

export default Gallery
